<!-- このコンポーネントはサイドメニューとコンテンツの2カラムパターンで使用します -->
<template>
	<div class="l_contents">
		<div class="contents_inner">
			<!-- タイトル表示 -->
			<slot name="title"></slot>
			<!-- コンテンツ表示 -->
			<slot name="contents"></slot>
		</div>
	</div>
</template>

<script setup></script>
